import React, {PureComponent} from 'react'
import {NotificationManager} from 'modules/Common/components/Notification'
import ReactS3Uploader from 'react-s3-uploader'
import {toUpper} from 'lodash'
import I18n from 'I18n'
import {Link} from 'react-router-dom'
import styles from './EditCompany.module.scss'
import 'react-table/react-table.css'

import {adminURL} from 'modules/Common/constants'
import errorCodeHandle from 'modules/Common/utils/errorCodeHandle'
import {getSignedUrl, preProcessUploadAvatar, parseCompanyData, ATTRIBUTES} from 'modules/Admin/utils'
import UploadIcon from '../svgIcons/upload.svg'


const I18nLocal = I18n.admin

const ATTRIBUTE_TYPES = {
  STRING: 'STRING',
  JSON_MAP: 'JSON_MAP'
}

const attributeBuilder = ({
  name,
  type,
  value
}) => {
  let result = null
  if (name && type) {
    result = {
      name,
      type,
      value
    }
  }

  return result
}

const findAndUpdateAttribute = ({
  name,
  type,
  value,
  attributes
}) => {
  let updatedAttributes = attributes

  const attribute = attributeBuilder({name, type, value})
  const oldAttributeIndex = updatedAttributes.findIndex((attr) => attr.name === name)
  if (oldAttributeIndex !== -1) {
    updatedAttributes.splice(oldAttributeIndex, 1, attribute)
  } else {
    updatedAttributes.push(attribute)
  }

  return updatedAttributes
}

const parseReverseCompanyInfo = (companyInfo) => {
  if (!companyInfo) return {}

  let updatedCompanyInfo = {...companyInfo}

  let attributes = []

  if (companyInfo.attributes) {
    attributes = [...companyInfo.attributes]
  }

  if (companyInfo['2faWecomBanner']) {
    attributes = findAndUpdateAttribute({name: ATTRIBUTES['2faWecomBanner'], type: ATTRIBUTE_TYPES.STRING, value: companyInfo['2faWecomBanner'], attributes})
  }
  delete updatedCompanyInfo['2faWecomBanner']
  updatedCompanyInfo.attributes = attributes

  return updatedCompanyInfo
}

export class EditCompany extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      company: null,
      oldName: ''
    }
  }

  handleSaveBtnClicked = () => {
    const company = this.state.company
    if (company) {
      const updatedCompany = parseReverseCompanyInfo(company)
      const detail = {
        company: {
          ...updatedCompany,
          fullName: company.fullName,
          location: company.location,
          sso: company.sso
        }
      }
      this.props.addOrUpdateCompany(detail).then(() => {
        if (!this.props.error) {
          NotificationManager.success(I18nLocal.changesSaved)
          this.props.history.push(adminURL.companies.index)
        } else {
          //eslint-disable-next-line
          console.log('<<< this.props.error', this.props.error)
          NotificationManager.error(
            errorCodeHandle(this.props.error.code, this.props.error.message)
          )
        }
      })
    }
  }

  componentDidMount() {
    const {match} = this.props
    if (match && match.params.id) {
      const id = match.params.id
      this.props.getCompanies(1, [id]).then(() => {
        this.setState({
          company: parseCompanyData(this.props.companies.records[id]),
          oldName: this.props.companies.records[id]
            ? this.props.companies.records[id].fullName
            : ''
        })
      })

      this.props.getCompanyProfile(id)
    }
  }

  onFinishUpload = (signResult, file, type) => {
    const company = this.state.company
    if (!company) return

    let updatedCompany = {
      ...company
    }

    const url = signResult.url.slice(0, signResult.url.indexOf('?'))

    if (type === 'logoUrl') {
      updatedCompany = {
        ...updatedCompany,
        logoUrl: url,
        loginLogoUrl: updatedCompany.loginLogoUrl || url
      }
    }

    if (type === 'loginLogoUrl') {
      updatedCompany = {
        ...updatedCompany,
        loginLogoUrl: url
      }
    }

    if (type === '2faWecomBanner') {
      updatedCompany = {
        ...updatedCompany,
        '2faWecomBanner': url
      }
    }
    
    this.setState({company: updatedCompany})
  }

  hanldeChange = (value, key) => {
    switch (key) {
      case 'fullName':
      case 'location':
        let company = {...this.state.company}
        company[key] = value
        this.setState({company})
        break
      default:
    }
  }

  checkIsNotHaveEmptyField = () => {
    const company = this.state.company
    return company && company.fullName && company.location
  }

  handleChangeSSOToggle = (e) => {
    let company = {...this.state.company}
    company['sso'] = e.target.checked
    this.setState({company})
    if (e.target.checked) {
      NotificationManager.info(I18nLocal.onSSO)
    } else {
      NotificationManager.info(I18nLocal.offSSO)
    }
  }
  render() {
    const company = this.state.company || {}
    const checkIsNotHaveEmptyField = this.checkIsNotHaveEmptyField()
    const {companyProfile} = this.props
    return (
      <div className={styles.container}>
        <div className={styles.header}>
          <span>{`${I18nLocal.editCompany} - ${this.state.oldName}`}</span>
        </div>
        <div className={styles.form}>
          <div className={styles.input}>
            <span>{toUpper(I18nLocal.companyName)}</span>
            <input
              type='text'
              placeholder={I18nLocal.companyName}
              value={company.fullName || ''}
              onChange={e => {
                this.hanldeChange(e.target.value, 'fullName')
              }}
            />
          </div>
          <div className={styles.input}>
            <span>{toUpper(I18nLocal.location)}</span>
            <input
              type='text'
              placeholder={I18nLocal.location}
              value={company.location}
              onChange={e => {
                this.hanldeChange(e.target.value, 'location')
              }}
            />
          </div>
        </div>
        <div className={styles.form}>
          <div className={styles.input}>
            <span>{toUpper(I18nLocal.logo)}</span>
            <img src={company.logoUrl} alt='' />
            <div className={styles['upload-button']} onClick={() => {}}>
              <UploadIcon width={20} height={20} />
              <ReactS3Uploader
                className={styles['upload-input']}
                getSignedUrl={getSignedUrl}
                accept='image/jpeg,image/png,image/gif'
                contentDisposition='auto'
                autoUpload={true}
                preprocess={preProcessUploadAvatar}
                onFinish={(signResult, file) => {this.onFinishUpload(signResult, file, 'logoUrl')}}
                uploadRequestHeaders={{'x-amz-acl': 'public-read'}}
              />
            </div>
          </div>
        </div>
        <div className={styles.form}>
          <div className={styles.input}>
            <span>{toUpper(I18nLocal.logoLogin)}</span>
            <img src={company.loginLogoUrl} alt='' />
            <div className={styles['upload-button']} onClick={() => {}}>
              <UploadIcon width={20} height={20} />
              <ReactS3Uploader
                className={styles['upload-input']}
                getSignedUrl={getSignedUrl}
                accept='image/jpeg,image/png,image/gif'
                contentDisposition='auto'
                autoUpload={true}
                preprocess={preProcessUploadAvatar}
                onFinish={(signResult, file) => {this.onFinishUpload(signResult, file, 'loginLogoUrl')}}
                uploadRequestHeaders={{'x-amz-acl': 'public-read'}}
              />
            </div>
          </div>
        </div>
        <div className={styles.form}>
          <div className={styles.input}>
            <span>{toUpper(I18nLocal['2faWecomBanner'])}</span>
            <img src={company['2faWecomBanner']} alt='' />
            <div className={styles['upload-button']} onClick={() => {}}>
              <UploadIcon width={20} height={20} />
              <ReactS3Uploader
                className={styles['upload-input']}
                getSignedUrl={getSignedUrl}
                accept='image/jpeg,image/png,image/gif'
                contentDisposition='auto'
                autoUpload={true}
                preprocess={preProcessUploadAvatar}
                onFinish={(signResult, file) => {this.onFinishUpload(signResult, file, '2faWecomBanner')}}
                uploadRequestHeaders={{'x-amz-acl': 'public-read'}}
              />
            </div>
          </div>
        </div>
        <div className={styles.form}>
          <div className={styles.input}>
            <span>{toUpper(I18nLocal.sso)}</span>
            <div className={styles['toggle-ctn']}>
              <input
                className={`${styles.tgl} ${styles['tgl-light']}`}
                type='checkbox'
                id='sso'
                onChange={e => this.handleChangeSSOToggle(e)}
                checked={company.sso || false}
              />
              <label className={styles['tgl-btn']} htmlFor='sso' />
            </div>
          </div>
        </div>
        <div className={styles.form}>
          <div className={styles.input}>
            <span>{toUpper(I18nLocal.whatsappNative)}</span>
            <div className={styles['toggle-ctn']}>
              <input
                className={`${styles.tgl} ${styles['tgl-light']}`}
                type='checkbox'
                id='whatsapp-native'
                checked={
                  companyProfile && companyProfile.whatsappConfigured === 'true'
                }
              />
              <label className={styles['tgl-btn']} htmlFor='whatsapp-native' />
            </div>
          </div>
        </div>
        <hr />
        <div className={styles.buttons}>
          <Link to={adminURL.companies.index} className={`${styles.button} ${styles.red}`}>
            {I18nLocal.cancel}
          </Link>
          <div
            className={`${styles.button} ${!checkIsNotHaveEmptyField ? styles.inactive : ''}`}
            onClick={() => {
              checkIsNotHaveEmptyField && this.handleSaveBtnClicked()
            }}
          >
            {I18nLocal.save}
          </div>
        </div>
        <hr />
      </div>
    )
  }
}

export default EditCompany
